export default {
  nav: {
    main: 'Головна',
    ordersAndInvoices: 'Замовлення та рахунки',
    drafts: 'Чернетки',
    automation: 'Автоматизація',
    workspace: 'Робочий простір',
    templates: 'Шаблони',
    delivery: 'Доставка',
    settings: 'Налаштування',
    shippingLabels: 'Транспортні етикетки',
    subscriptions: 'Підписки',
    support: 'Підтримка',
    developer: 'Розробник',
    writeReview: 'Написати відгук',
    supportTicket: 'Запит до підтримки',
    welcomeTour: 'Ознайомчий тур',
    administratorConsole: 'Консоль адміністратора',
    logout: 'Вийти',
  },
  dashboard: {
    pageTitle: 'Замовлення та рахунки',
    pageDescription: 'Manage your orders and invoices',
    title: 'Замовлення та рахунки',
    selectedOrders: '{count} вибраних замовлень',
    completed: '% завершено',
    processing: 'Обробка, зачекайте...',
    bulkDownload: 'Масове завантаження',
    upgradeBulkDownload: 'Оновіть план для масового завантаження',
    showFilters: 'Показати фільтри',
    hideFilters: 'Сховати фільтри',
    creatingInvoices: 'Створення рахунків, зачекайте...',
    bulkCreateInvoices: 'Масове створення рахунків',
    cannotCreateAutopilot: 'Ви не можете створювати рахунки вручну, коли режим виставлення рахунків працює на автопілоті.',
    exportInvoices: 'Експорт рахунків або замовлень',
    capturePayments: 'Захопити платежі вручну',
    filterOrders: 'Фільтрувати замовлення',
    error: 'Ой, щось пішло не так...',
    close: 'Закрити',
    chooseDate: 'Оберіть дату',
    chooseIssueDate: 'Оберіть дату виставлення для вибраних рахунків',
    cancel: 'Скасувати',
    createInvoices: 'Створити рахунки',
    storno: 'Сторно',
    bulkOrderCapture: 'Масове захоплення замовлень',
  },
  search: {
    createdBetween: 'Створено між',
    modifiedBetween: 'Змінено між',
    orderNumber: 'Замовлення №',
    invoiceNumber: 'Рахунок №',
    refundNumber: 'Повернення №',
    customer: 'Клієнт',
    payment: 'Оплата',
    any: 'Будь-який',
    authorized: 'Авторизовано',
    pending: 'Очікує',
    paid: 'Сплачено',
    partiallyPaid: 'Частково сплачено',
    refunded: 'Повернуто',
    voided: 'Анульовано',
    partiallyRefunded: 'Частково повернуто',
    unpaid: 'Не сплачено',
    fulfillment: 'Виконання',
    fulfilled: 'Відправлено',
    partial: 'Часткова',
    unfulfilled: 'Не відправлено',
    loading: 'Завантаження замовлень...',
    search: 'Пошук',
  },
  orderList: {
    noCustomer: 'Немає клієнта',
    downloadOrder: 'Завантажити замовлення',
    deleteWarning: 'Увага! Це видалить усі рахунки та повернення, створені після дати:',
    includingInvoice: 'включаючи вибраний рахунок №',
    pressOk: 'Натисніть OK, щоб продовжити, або Скасувати, щоб відмінити.',
    cannotCreateAutopilot: 'Ви не можете створювати рахунки вручну, коли режим виставлення рахунків працює на автопілоті.',
    createInvoice: 'Створити рахунок для цього замовлення',
    create: 'Створити',
    addCreditNote: 'Додати кредитну ноту',
    createStorno: 'Створити сторно-рахунок',
    refund: 'Повернення',
    downloadInvoice: 'Завантажити цей рахунок',
    download: 'Завантажити',
    default: 'За замовчуванням',
    downloadStorno: 'Завантажити цей сторно/кредитну ноту',
    fulfillOrder: 'Виконати замовлення',
    orderNum: 'Замовлення №',
    locPrefix: 'Префікс локації',
    invoiceNum: 'Рахунок №',
    refundNum: 'Повернення №',
    customerCol: 'Клієнт',
    orderCreatedDate: 'Дата створення замовлення',
    orderModifiedDate: 'Дата зміни замовлення',
    delivered: 'Доставлено',
    paymentStatus: 'Статус оплати',
    fulfillmentStatus: 'Статус доставки',
    totalOutstanding: 'Загальна заборгованість',
    originalPrice: 'Початкова ціна',
    noOrders: 'У вашому магазині немає замовлень для вибраного статусу.',
    cannotCreateNoOrders: 'Ви не можете створити рахунки, коли немає замовлень.',
    createOrdersFirst: 'Будь ласка, створіть хоча б одне замовлення та спробуйте знову.',
    createOrders: 'Створити замовлення',
    loadingOrders: 'Завантаження...',
    paidManual: 'Сплачено - Вручну',
    paid: 'Сплачено',
    refunded: 'Повернуто',
    pending: 'Очікує',
    partiallyPaid: 'Частково сплачено',
    partiallyRefunded: 'Частково повернуто',
    fulfilled: 'Відправлено',
    unfulfilled: 'Не відправлено',
    deliveryPending: 'Очікує',
    deliverNow: 'Доставити зараз',
    deliveryPartial: 'Часткова',
    notDelivered: 'Не доставлено',
    deliverAgain: 'Доставити знову',
    deliveryDetails: 'Деталі доставки',
    deliveryFailed: 'Доставка невдала',
    sent: 'Надіслано',
    failed: 'Невдало',
    toLabel: 'Кому',
    folderLabel: 'Папка',
    open: 'Відкрито',
    invoice: 'Рахунок',
    creditNote: 'Кредитна нота',
    stornoLabel: 'Сторно',
    unknown: 'Невідомо',
    googleDrive: 'Google Drive',
    clientsTablet: 'Планшет клієнтів',
    shippyPro: 'ShippyPro',
    emailChannel: 'Ел. пошта',
    ftpChannel: 'FTP',
    revertToDate: 'Повернути до цієї дати',
    add: 'Додати',
    close: 'Закрити',
  },
  downloadDialog: {
    downloadType: 'Завантажити {type}...',
    selectTemplate: 'Оберіть шаблон з галереї для експорту замовлень, рахунків, сторно-рахунків або кредитних нот.',
    getMoreTemplates: 'Отримати більше шаблонів',
    createNewTemplate: 'Створити новий шаблон',
    allCreatedBetween: 'Усі створені {type} між',
    selectedType: 'Вибрані {type}',
    and: 'та',
    status: 'Статус',
    any: 'Будь-який',
    open: 'Відкрито',
    closed: 'Закрито',
    cancelled: 'Скасовано',
    paymentStatus: 'Статус оплати',
    fulfillmentStatus: 'Статус доставки',
    fulfilled: 'Відправлено',
    partial: 'Часткова',
    unfulfilled: 'Не відправлено',
    authorized: 'Авторизовано',
    pending: 'Очікує',
    paid: 'Сплачено',
    partiallyPaid: 'Частково сплачено',
    refunded: 'Повернуто',
    voided: 'Анульовано',
    partiallyRefunded: 'Частково повернуто',
    unpaid: 'Не сплачено',
    format: 'Формат',
    forLocation: 'Для локації',
    advancedOptions: 'Додаткові параметри',
    exportHSCodes: 'Експорт HS-кодів інвентарю (повільніше)',
    noteChrome: 'Примітка: Для оптимального завантаження рекомендується Chrome та вимкнення блокувальника реклами.',
    downloadIndividually: 'Завантажити окремо',
    downloadGrouped: 'Завантажити групою',
  },
  templates: {
    pageTitle: 'Шаблони',
    pageDescription: 'Customize your invoice templates',
    title: 'Шаблони',
    installTranslated: 'Встановити перекладений шаблон',
    installTranslatedDesc: 'Оберіть іншу мову, натиснувши цю кнопку.',
    createNew: 'Створити новий шаблон за потреби',
    createNewDesc: 'Натисніть цю кнопку, щоб створити новий шаблон за потреби.',
    customize: 'Налаштувати шаблони',
    customizeDesc: 'Натисніть на шаблон за замовчуванням, щоб налаштувати його. Ви можете змінити логотип, кольори, а для досвідчених користувачів — код.',
    defaultTemplate: 'Рахунок, сторно та кредитна нота (За замовчуванням)',
    logo: 'Логотип',
    colorPalette: 'Палітра кольорів',
    getColorPalettes: 'Отримати палітри кольорів',
    paperSize: 'Розмір паперу',
    format: 'Формат',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Орієнтація',
    landscape: 'Альбомна',
    portrait: 'Книжкова',
    margin: 'Поля (см)',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    save: 'Зберегти',
  },
  labels: {
    pageTitle: 'Транспортні етикетки',
    pageDescription: 'Create and manage shipping labels',
    title: 'Транспортні етикетки',
    glsRequiresPro: 'Транспортні етикетки GLS для країн ЄЕС потребують плану Professional.',
    upgradeDesc: 'Оновіть до Professional, щоб створювати та керувати транспортними етикетками.',
    upgradePlan: 'Оновити план',
    eeuGls: 'EEU GLS',
    enabled: 'Увімкнено',
    country: 'Країна',
    hungary: 'Угорщина',
    slovakia: 'Словаччина',
    czech: 'Чехія',
    romania: 'Румунія',
    slovenia: 'Словенія',
    croatia: 'Хорватія',
    senderId: 'ID відправника',
    username: 'Ім\'я користувача',
    password: 'Пароль',
    name: 'Назва',
    city: 'Місто',
    address: 'Адреса',
    zipCode: 'Поштовий індекс',
    contactPerson: 'Контактна особа',
    phone: 'Телефон',
    email: 'Електронна пошта',
    glsServices: 'Послуги GLS',
    expressService: 'Експрес-сервіс',
    exchangeService: 'Сервіс обміну',
    smsService: 'SMS-сервіс',
    smsText: 'Текст SMS',
    preAdviceService: 'Сервіс попереднього повідомлення',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    save: 'Зберегти',
  },
  billing: {
    pageTitle: 'Тарифи',
    pageDescription: 'Manage your subscription and billing',
    title: 'Тарифи',
    subscriptionFor: 'План підписки для магазину',
    currentlySubscribed: 'Зараз ви підписані на',
    plan: 'план',
    cancelSubscription: 'Скасувати підписку',
    upgradePlan: 'Оновити план',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / місяць',
    upgrade: 'Оновити',
    includesAllStarter: 'Включає всі функції Starter, а також:',
    proFeature1: 'Глобальний пакет відповідності: Префікси на основі розташування та індивідуальна послідовна нумерація',
    proFeature2: 'Розумна локалізація: Автоматично перекладені листи та локалізовані PDF-вкладення',
    proFeature3: 'Повний цикл B2B документів: Проформи, B2B пропозиції та кредитні ноти',
    proFeature4: 'Синхронізація B2B бухгалтерії: Точність до 3 десяткових знаків та мультивалютне відображення',
    proFeature5: 'Автоматичне резервне копіювання: Копіювання рахунків на захищений FTP або Google Drive',
    proFeature6: 'Shopify Flow: Автоматизація генерації, доставки та сторно рахунків через тригери та дії Flow',
    proFeature7: 'Розширена логіка ШІ: Використання локального ШІ для складних умовних макетних виразів',
    proFeature8: 'Експорт UBL XML та ZUGFeRD / Factur-X (відповідність європейському електронному рахуванню)',
    proFeature9: 'Коди EPC QR для миттєвих мобільних POS-платежів',
    proFeature10: 'Транспортні етикетки GLS для ЄЕС',
    proFeature11: '7-річне зберігання для податкової відповідності',
    currentlyUsing: 'Зараз ви використовуєте наш',
    free: 'безкоштовний',
    subscriptionPlan: 'план підписки.',
    monthlyUsage: 'Щомісячне використання',
    monthlyGenerated: '{count} / 50 рахунків цього місяця',
    monthlyLimitReached: 'Місячний ліміт вичерпано. Оновіть до Starter для необмежених рахунків.',
    freePlan: 'Безкоштовний план',
    freeToInstall: 'Безкоштовне встановлення',
    freeFeature1: 'До 50 рахунків/замовлень на місяць',
    freeFeature2: 'Доступ до всіх 31+ попередньо визначених шаблонів',
    freeFeature3: 'Базовий ШІ-копілот',
    freeFeature4: 'Стандартне завантаження та друк PDF',
    freeFeature5: 'Стандартний набір документів (Рахунки, Пакувальні листи, Квитанції)',
    freeFeature6: '3-місячне безпечне зберігання рахунків',
    starterPlan: 'План Starter',
    starterPrice: '$9.99 / місяць',
    starterPricePerInvoice: '+ 3¢ за створений рахунок',
    subscribe: 'Підписатися',
    starterFeature1: 'Необмежена кількість рахунків та замовлень',
    starterFeature2: 'Автоматична доставка PDF електронною поштою',
    starterFeature3: 'Повний доступ до гібридного редактора та ШІ-копілота',
    starterFeature4: 'Інтеграція з Shopify POS та штрих-кодами',
    starterFeature5: 'Shopify Flow: Тригери та дії для автоматизації рахунків',
    starterFeature6: 'Експорт UBL XML / PEPPOL та ZUGFeRD / Factur-X (відповідність електронному рахуванню)',
    starterFeature7: '1-річне безпечне зберігання рахунків',
    proTaxOverrides: 'Індивідуальне перевизначення податків: ПДВ / GST за продуктом та ставки на рівні SKU',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    save: 'Зберегти',
  },
  autopilot: {
    pageTitle: 'Автоматизація',
    pageDescription: 'Automate invoice creation and management',
    title: 'Автоматизація',
    autoCreate: 'Автоматично створювати рахунки',
    disabled: 'Вимкнено (Вручну)',
    whenCreated: 'Коли замовлення створені',
    whenFulfilled: 'Коли замовлення виконані',
    whenPaid: 'Коли замовлення оплачені',
    autoCreateDesc: 'Рахунки будуть створені на дату, коли замовлення створені, виконані або оплачені.',
    autoStorno: 'Автоматично створювати сторно-рахунки',
    whenCancelled: 'Коли замовлення скасовані або повернені',
    autoStornoDesc: 'Сторно-рахунки будуть створені на дату, коли замовлення анульовані/скасовані або створені повернення.',
    cannotAutoFree: 'Автоматичне створення рахунків недоступне на безкоштовному плані.',
    upgradePlan: 'Оновити план',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    save: 'Зберегти',
  },
  delivery: {
    pageTitle: 'Доставка',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Доставка',
    settings: 'Налаштування',
    useOrderNumbers: 'Використовувати номери замовлень для файлів',
    sendIfCountry: 'Надсилати, якщо країна адреси виставлення рахунку',
    countryCodesHint: 'Перелічіть усі коди країн через крапку з комою.',
    sendForTags: 'Надсилати для клієнтів, які мають один із вказаних тегів',
    tagsHint: 'Перелічіть усі теги через крапку з комою.',
    emailDelivery: 'Доставка електронною поштою',
    sendAsPdf: 'Надсилати рахунки як PDF-вкладення клієнтам',
    autoSend: 'Автоматично надсилати при створенні рахунку',
    subject: 'Тема',
    body: 'Текст листа',
    xmlAttachments: 'XML-вкладення',
    attachUbl: 'Вкласти UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Вкласти ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Надіслати тестовий лист',
    sending: 'Надсилання...',
    customSmtp: 'Користувацький сервер SMTP',
    customSmtpDesc: 'Використовувати власний поштовий сервер замість стандартного',
    enableSmtp: 'Увімкнути користувацький SMTP',
    smtpHost: 'Хост SMTP',
    port: 'Порт',
    useSsl: 'Використовувати SSL/TLS',
    username: 'Ім\'я користувача',
    password: 'Пароль',
    fromEmail: 'Електронна адреса відправника',
    fromName: 'Ім\'я відправника',
    shopifyLiquid: 'Шаблон Shopify Liquid',
    pasteInto: 'Вставте це у ваш',
    orderConfirmation: 'шаблон підтвердження замовлення',
    toAddLink: 'щоб додати посилання для завантаження.',
    downloadInvoice: 'Завантажити ваш рахунок',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Надсилати запити до ClientsTablet при створенні рахунків',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Надсилати PDF-рахунки як митні документи до ShippyPro для країн поза ЄС',
    ftpBackup: 'Резервне копіювання FTP/SFTP',
    ftpDesc: 'Автоматично копіювати рахунки на ваш сервер',
    enableFtp: 'Увімкнути автоматичне резервне копіювання FTP',
    host: 'Хост',
    useSftp: 'Використовувати SFTP (захищений)',
    destinationFolder: 'Папка призначення',
    xmlFiles: 'XML-файли',
    includeUbl: 'Включити UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Включити ZUGFeRD / Factur-X XML',
    testConnection: 'Перевірити з\'єднання',
    testing: 'Перевірка...',
    pro: 'PRO',
    upgradeFtp: 'Оновіть до Professional, щоб автоматично копіювати рахунки на ваш сервер FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Автоматично синхронізувати рахунки на ваш Drive',
    connected: 'Підключено',
    disconnect: 'Відключити',
    notWorking: 'Не працює? Перейдіть до',
    googlePermissions: 'Дозволи Google',
    removeThenReconnect: 'видаліть Invoice Browse, потім підключіться знову.',
    connectGoogleDrive: 'Підключити Google Drive',
    upgradeGoogleDrive: 'Оновіть до Professional, щоб автоматично синхронізувати рахунки з Google Drive.',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Зберегти',
  },
  bookkeeping: {
    pageTitle: 'Налаштування',
    pageDescription: 'Configure your invoice settings',
    title: 'Налаштування',
    owner: 'Власник',
    email: 'Електронна пошта',
    phone: 'Телефон',
    keepDifferentNumbering: 'Зберігати різну нумерацію рахунків для кожного місця замовлення',
    keepDifferentNumberingDisabled: 'Зберігати різну нумерацію рахунків для кожного місця замовлення недоступно на вашому плані.',
    locationEmailDesc: 'Це дозволяє надсилати електронні листи та рахунки, перекладені на основі місця замовлення: місце інвентаризації, адреса доставки або адреса виставлення рахунку',
    upgradePlan: 'Оновити план',
    matchingCriteria: 'Критерії відповідності',
    locationId: 'ID місця',
    shippingCountryCode: 'Код країни адреси доставки',
    billingCountryCode: 'Код країни адреси виставлення рахунку',
    matchLocationDesc: 'Визначати місце на основі ID місця замовлення, коду країни адреси доставки або виставлення рахунку.',
    companyInfo: 'Інформація про компанію',
    name: 'Назва',
    website: 'Веб-сайт',
    registrationNumber: 'Реєстраційний номер',
    taxId: 'Податковий номер',
    addressSection: 'Адреса',
    streetName: 'Назва вулиці',
    streetNumber: 'Номер будинку',
    zip: 'Поштовий індекс',
    city: 'Місто',
    region: 'Область',
    country: 'Країна',
    bankingInfo: 'Банківська інформація',
    bankName: 'Назва банку',
    swift: 'Swift',
    currency: 'Валюта',
    iban: 'IBAN',
    invoicing: 'Рахунки',
    decimalPlaces: 'Десяткові знаки',
    invoicesPrefix: 'Префікс рахунків',
    currentInvoiceNumber: 'Поточний номер рахунку',
    creditNotesPrefix: 'Префікс кредитних нот',
    currentCreditNoteNumber: 'Поточний номер кредитної ноти',
    lastInvoiceDate: 'Дата останнього рахунку',
    noInvoicesYet: 'Рахунки ще не створювались.',
    confirmReverting: 'Підтвердження скасування системи',
    allInvoicesAfter: 'Усі рахунки та їх сторно, видані після',
    willBeRemoved: 'будуть видалені. Продовжити скасування системи?',
    cancel: 'Скасувати',
    revert: 'Скасувати',
    revertDesc: 'Скасування системи видалить усі рахунки, створені після вибраної дати.',
    revertToDate: 'Скасувати до цієї дати',
    reverting: 'Скасування системи, зачекайте...',
    useOrderNumbering: 'Використовувати нумерацію замовлень',
    showVat: 'Показувати ПДВ на рахунках',
    overrideTaxes: 'Перевизначити податки',
    pricesIncludeTax: 'Ціни включають податок',
    productsTaxRate: 'Ставка податку на товари',
    shippingTaxRate: 'Ставка податку на доставку',
    skusSeparated: 'SKU через крапку з комою',
    skusTaxRate: 'Ставка податку за SKU',
    useOrderDates: 'Використовувати дати створення замовлень для рахунків',
    convertCurrency: 'Конвертувати ціни у валюту, якою платить клієнт',
    unsavedChanges: 'Незбережені зміни',
    discard: 'Відхилити',
    save: 'Зберегти',
  },
  drafts: {
    pageTitle: 'Чернетки',
    pageDescription: 'Manage your draft orders',
    title: 'Чернетки',
    download: 'Завантажити',
    newDraft: 'Нова чернетка',
    exporting: 'Експорт {status}%...',
    accessNotGranted: 'Доступ до чернеток замовлень не надано. Будь ласка',
    reLogin: 'увійдіть повторно',
    toGrantPermissions: 'щоб надати необхідні дозволи "Чернетки замовлень".',
    pushFailed: 'Відправка до Shopify не вдалася:',
    exportError: 'Помилка експорту:',
    confirmDelete: 'Ви впевнені, що хочете видалити цю чернетку?',
    incompleteCustomer: 'Дані клієнта неповні:',
    pushWithoutCustomer: 'Чернетку буде відправлено до Shopify без даних клієнта. Продовжити?',
    customerNotInShopify: 'Цей клієнт ще не існує в Shopify.',
    warnings: 'Попередження:',
    createCustomerAndPush: 'Створити клієнта в Shopify та відправити чернетку замовлення?',
    downloadTitle: 'Завантажити чернетки',
    cancel: 'Скасувати',
  },
  draftEdit: {
    number: "Номер",
    prefix: "Префікс",

    newDraft: 'Нова чернетка',
    editDraft: 'Редагувати чернетку',
    viewInShopify: 'Переглянути в Shopify',
    back: 'Назад',
    createDraft: 'Створити чернетку',
    saveChanges: 'Зберегти зміни',
    documentType: 'Тип документа',
    draftOrder: 'Чернетка замовлення',
    quote: 'Комерційна пропозиція',
    proforma: 'Проформа',
    manualInvoice: 'Ручний рахунок',
    currency: 'Валюта',
    expiryDate: 'Дата закінчення',
    status: 'Статус',
    draft: 'Чернетка',
    sent: 'Надіслано',
    accepted: 'Прийнято',
    customer: 'Клієнт',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    email: 'Електронна пошта',
    phone: 'Телефон',
    company: 'Компанія',
    taxId: 'Податковий номер',
    billingAddress: 'Адреса виставлення рахунку',
    address: 'Адреса',
    aptSuite: 'Кв./Офіс',
    city: 'Місто',
    province: 'Область',
    countryField: 'Країна',
    zip: 'Поштовий індекс',
    shippingAddress: 'Адреса доставки',
    sameAsBilling: 'Така ж, як адреса виставлення рахунку',
    lineItems: 'Позиції',
    shipping: 'Доставка',
    shippingTitle: 'Назва',
    shippingPlaceholder: 'напр. Стандартна доставка',
    price: 'Ціна',
    note: 'Примітка',
    notePlaceholder: 'Внутрішня примітка або повідомлення клієнту...',
    summary: 'Підсумок',
    subtotal: 'Проміжний підсумок',
    discounts: 'Знижки',
    tax: 'Податок',
    total: 'Всього',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Введіть адресу вашого магазину',
    loginWith: 'Увійти через',
    createAccount: 'Створити новий обліковий запис',
    placeholder: 'назва-вашого-магазину',
    shopRequired: 'Назва магазину обов\'язкова',
    login: 'Увійти',
    shopify: 'Shopify',
    terms: 'Умови та положення',
    privacy: 'Політика конфіденційності',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Вам подобається Invoice Browse?',
    description: 'Ви створили свої перші рахунки! Якщо додаток вам корисний, короткий відгук у Shopify App Store дуже нам допоможе.',
    reward: 'На подяку ми скинемо ваш місячний лічильник використання до 0',
    leaveReview: 'Залишити відгук',
    maybeLater: 'Можливо, пізніше',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Ласкаво просимо до Invoice Browse',
    welcomeContent: 'Дозвольте показати вам, як користуватися додатком.',
    dashboardTitle: 'Панель керування',
    dashboardContent: 'Екран, який ви бачите, — це головна панель керування. Тут ви можете знайти всі замовлення та експортувати їх у різні типи документів, як-от: рахунки, пакувальні листи та інші.',
    automationTitle: 'Спростіть своє життя',
    automationContent: 'Увімкніть автоматизацію, щоб створювати рахунки щоразу, коли замовлення оплачені або повернені.',
    templatesTitle: 'Налаштувати шаблони',
    templatesContent: 'Зайдіть сюди, щоб перекласти шаблон, налаштувати його або створити новий.',
    deliveryTitle: 'Доставка',
    deliveryContent: 'Налаштуйте додаток для автоматичного копіювання створених документів на FTP, Google Drive або у вигляді вкладень до електронних листів.',
    settingsTitle: 'Налаштування',
    settingsContent1: 'Налаштуйте номер телефону компанії, електронну пошту та інші поля, що використовуються в документах.',
    settingsContent2: 'Змініть початковий номер документа або видаліть документи, створені після певної дати.',
    settingsContent3: 'Перевизначіть ставки ПДВ для доставки та товарів',
    settingsContent4: 'Змініть кількість десяткових знаків для чисел',
    reviewTitle: 'Написати відгук',
    reviewContent: 'Підтримайте нашу команду, написавши хороший відгук!',
    tourTitle: 'Ознайомчий тур',
    tourContent: 'Ви можете відкрити цей тур знову звідси.',
    createDocTitle: 'Створіть ваш перший документ',
    createDocContent: 'Натисніть кнопку Створити, щоб створити ваш перший документ.',
    docNumberTitle: 'Номер документа',
    docNumberContent: 'Першому документу присвоєно номер 1. Якщо ви хочете почати з іншого номера, ви можете змінити це в Налаштуваннях.',
    downloadDocTitle: 'Завантажити документ',
    downloadDocContent: 'Натисніть на випадаючий список Завантажити та оберіть шаблон документа для експорту замовлення у PDF.',
  },
  common: {
    save: 'Зберегти',
    cancel: 'Скасувати',
    close: 'Закрити',
    discard: 'Відхилити',
    delete: 'Видалити',
    edit: 'Редагувати',
    create: 'Створити',
    loading: 'Завантаження...',
    unsavedChanges: 'Незбережені зміни',
    upgradePlan: 'Оновити план',
  },
  languageSelector: {
    label: 'Мова',
    auto: 'Автовизначення',
  },
  draftList: {
    draftNum: 'Чернетка #',
    shopifyId: 'Shopify ID',
    type: 'Тип',
    customer: 'Клієнт',
    total: 'Всього',
    status: 'Статус',
    delivered: 'Доставлено',
    date: 'Дата',
    actions: 'Дії',
    noCustomer: 'Немає клієнта',
    noDrafts: 'Чернеток або пропозицій не знайдено.',
    loading: 'Завантаження...',
    download: 'Завантажити',
    default: 'За замовчуванням',
    pending: 'Очікує',
    deliverNow: 'Доставити зараз',
    deliveryDetails: 'Деталі доставки',
    sent: 'Надіслано',
    failed: 'Невдало',
    deliverAgain: 'Доставити знову',
    partial: 'Часткове',
    notDelivered: 'Не доставлено',
    deliveryFailed: 'Доставка не вдалася',
    unknown: 'Невідомо',
    edit: 'Редагувати',
    send: 'Надіслати',
    pushToShopify: 'Надіслати в Shopify',
    complete: 'Завершити',
    duplicate: 'Дублювати',
    delete: 'Видалити',
    quote: 'Пропозиція',
    proforma: 'Проформа',
    draftOrder: 'Чернетка замовлення',
    manualInvoice: 'Ручний рахунок',
  },
  draftSearch: {
    createdBtw: 'Створено між',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Клієнт',
    status: 'Статус',
    type: 'Тип',
    delivery: 'Доставка',
    any: 'Усі',
    draft: 'Чернетка',
    sent: 'Надіслано',
    accepted: 'Прийнято',
    expired: 'Закінчилось',
    converted: 'Конвертовано',
    cancelled: 'Скасовано',
    quote: 'Пропозиція',
    proforma: 'Проформа',
    draftOrder: 'Чернетка замовлення',
    manualInvoice: 'Ручний рахунок',
    delivered: 'Доставлено',
    notDelivered: 'Не доставлено',
    pending: 'Очікує',
    search: 'Пошук',
  },
  draftDownload: {
    title: 'Завантажити Чернетка #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Статус',
    documentType: 'Тип',
    any: 'Усі',
    draft: 'Чернетка',
    sent: 'Надіслано',
    accepted: 'Прийнято',
    expired: 'Закінчилось',
    converted: 'Конвертовано',
    cancelled: 'Скасовано',
    quote: 'Пропозиція',
    proforma: 'Проформа',
    draftOrder: 'Чернетка замовлення',
    manualInvoice: 'Ручний рахунок',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Встановити новий шаблон',
    tabStyle: 'Стиль',
    tabContent: 'Вміст',
    tabTranslations: 'Переклади',
    tabSettings: 'Налаштування',
    tabCode: 'Код',
    tabCopilot: 'AI Копілот',
    logo: 'Логотип',
    colorPalette: 'Кольорова палітра',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/uk.js